import AuthApi from '@/api/account/auth'
import uiHelper from '@/helpers/ui'

export default {
  namespaced: true,

  state: {
    userData: null,
    authToken: ''
  },

  getters: {
    authToken: state => state['authToken'],
    userData: state => state['userData'],
    userId(state) {
      return state.userData.id
    }
  },

  mutations: {
    setUserData(state, data) {
      state.userData = data
    },

    setAuthToken(state, token) {
      state.authToken = token
    },

    clearAuthData(state) {
      state.userData = null
      state.authToken = ''
    }
  },

  actions: {
    async login({ commit }, data) {
      uiHelper.progressBarStatus(true)

      try {
        const response = await AuthApi.login({
          email: data.email,
          password: data.password
        })
        const { user } = response.data.payload
        const token = response.data.payload['auth-token']
        uiHelper.showSnackbarMessage(response.data.msg)

        commit('setAuthToken', token)
        commit('setUserData', user)
      } catch (error) {
        uiHelper.showSnackbarMessage('Invalid email or password.', 'error')
        throw error
      } finally {
        uiHelper.progressBarStatus(false)
      }
    },

    async loginWithToken({ commit, dispatch }, token) {
      try {
        const {
          data: { payload }
        } = await AuthApi.loginWithToken(token)
        const { user } = payload
        const { active_business } = payload
        commit('setAuthToken', token)
        commit('setUserData', user)
        if (active_business) {
          commit('user/setSelectedBusinessId', active_business.id, {
            root: true
          })
          await dispatch('user/getAllBusinesses', null, { root: true })
        }
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        throw error
      } finally {
        uiHelper.progressBarStatus(false)
      }
    },

    async logout({ commit }) {
      try {
        await AuthApi.logout()
        uiHelper.showSnackbarMessage('Successfully logged out')
      } catch (error) {
        if (error.response?.data?.msg) {
          uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        }
      }
      commit('clearAuthData')
      localStorage.clear()
    }
  }
}
